class HDAnalytics {
	constructor(debug = false) {
		this.data = {
			event: null,
			page: null,
			user: {
				mobile: window.matchMedia("(any-pointer:coarse)").matches,
				agent: navigator.userAgent,
				language: navigator.language,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			},
		};
		this.e = false; // has Exit
		this.s = false; // has Sent
		this.i = false; // has interacted
		this.debug = debug;
	}

	init() {
		if (this.isBotEnvironment()) {
			return;
		}

		this.getPage();

		const activationInterval = setInterval(() => {
			if (navigator.userActivation.hasBeenActive || this.i) {
				clearInterval(activationInterval);
				this.i = true;
				this.sendView();
			}
		}, 100);

		document.addEventListener(
			"scroll",
			() => {
				this.i = true;
			},
			{ once: true },
		);

		window.addEventListener("pagehide", () => {
			this.exit(); // will not detect when a user switches to a new app on mobile etc
		});

		document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "hidden") {
				this.exit(); //tab hidden, but might come back
			}
		});
	}

	sendView() {
		if (this.s || !this.i || document.visibilityState !== "visible") {
			return;
		}
		this.data.event = "pageview";
		this.send();
	}

	exit() {
		if (this.e) {
			return; // only fire off once
		}

		this.e = true;
		this.data.event = "exit";
		this.data.page.time = Date.now() - this.data.page.time; // time on page

		if (navigator.sendBeacon) {
			const blob = new Blob([JSON.stringify(this.data)], { type: "application/json" });
			navigator.sendBeacon(HDAD.a, blob);
			return;
		}
	}

	isBotEnvironment() {
		if (navigator.webdriver || window.Cypress || window._phantom || window.__nightmare) return true;
		if (!navigator.languages || navigator.languages.length === 0) return true;
		const w = window.innerWidth;
		const h = window.innerHeight;
		if (w < 100 || h < 100) return true;
		if ((w === 800 && h === 600) || (w === 1024 && h === 768)) {
			return true;
		}
		return false;
	}

	getPage() {
		let load_time = 0;
		const navEntries = performance.getEntriesByType("navigation");

		if (navEntries.length > 0) {
			const navEntry = navEntries[navEntries.length - 1];
			load_time = navEntry.domInteractive;
		}

		const urlParams = new URLSearchParams(window.location.search);
		const utm = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
		let sources = {};
		for (let i = 0; i < utm.length; i++) {
			let d = urlParams.get(utm[i]);
			if (d === null || d == "") {
				continue;
			}
			sources[utm[i]] = d;
		}

		this.data.page = {
			time: Date.now(),
			host: window.location.host,
			href: window.location.href,
			path: window.location.pathname,
			referrer: document.referrer,
			sources: sources,
			performance: load_time,
			page_id: HDAD.b,
			is_term: HDAD.c,
		};
	}

	send(event = null) {
		if (event !== null) {
			this.data.event = event;
		}
		if (this.s && this.data.event === "pageview") {
			return;
		} else {
			this.s = true;
		}

		fetch(HDAD.a, { method: "POST", headers: { "Content-Type": "application/json" }, keepalive: !0, body: JSON.stringify(this.data) }).then(async function (e) {
			if (HDA.debug) {
				console.log(await e.json());
			}
		});
	}
}

window.HDA = new HDAnalytics(HDAD.d);
window.addEventListener("load", function () {
	window.HDA.init();
});
